// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Header_logoWrapper__CYC2Y","logo":"Header_logo__8kTkW","logoText":"Header_logoText__aWxPI"};